import styles from './spinner.module.scss'
import loadingSpinnerGif from '../../../../asset/image/loading-spinner.gif'

export const Spinner = (): React.ReactElement => <img src={loadingSpinnerGif} alt="Loading..." className={styles.spinner} />
